module.exports = __webpack_public_path__ + "media/src/fonts/Lora-Italic-8c1c99dfe20cf335fc509f5d4f858813.woff2";